import React, { useState } from "react"

import "./index.scss"

function Header() {
  const [selectedTab, setSelectedTab] = useState(1)

  return (
    <div className="case-form__header">
      <h1>Inserir caso</h1>
      <div>
        <button
          className={`case-form__button ${
            selectedTab === 1 ? "case-form__button--selected" : ""
          }`}
          onClick={() => setSelectedTab(1)}
        >
          Manual
        </button>
        {/* <button
          className={`case-form__button ${
            selectedTab === 2 ? "case-form__button--selected" : ""
          }`}
          onClick={() => setSelectedTab(2)}
        >
          Importação
        </button> */}
      </div>
    </div>
  )
}

export default Header
